import { useEffect } from 'react';
import { getWhiteLabelConfigForHost } from 'config/whiteLabelDomains';

/**
 * Corrects the favicons to match the white-label brand of the current hostname.
 *
 * `_document` renders on the server, where there is no request hostname, so it emits the
 * default Thera icons. Once a single build serves several white-label domains those icons
 * are only right for Thera, and this fixes them up after hydration. Per-project builds
 * already render the correct icons, so this becomes a no-op for them.
 *
 * `brandingVersion` bumps when the backend branding row hydrates over the static config,
 * re-running the fixup with the freshly signed favicon URLs.
 */
export function useWhiteLabelFavicons(brandingVersion = 0): void {
  useEffect(() => {
    const config = getWhiteLabelConfigForHost(window.location.hostname);
    if (!config) {
      return;
    }

    const apply = (sizes: string, href: string) => {
      const link = document.querySelector<HTMLLinkElement>(`link[rel="icon"][sizes="${sizes}"]`);
      if (link && link.getAttribute('href') !== href) {
        link.setAttribute('href', href);
      }
    };

    apply('32x32', config.favicons.favicon32);
    apply('16x16', config.favicons.favicon16);
  }, [brandingVersion]);
}
